import { ExpandMore } from "@mui/icons-material";
import { Accordion, AccordionSummary, Box } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import TextToImageAspectRatio from "../../../../../../Playground/TextToImage/Config/Advanced/AspectRatio/TextToImageAspectRatio";
import TextToImageSeed from "../../../../../../Playground/TextToImage/Config/Advanced/Seed/TextToImageSeed";
import TextToImageGuidance from "../../../../../../Playground/TextToImage/Config/Advanced/TextGuidance/TextToImageGuidance";
import TextToImageControlNet from "../../../../../../Playground/TextToImage/Config/Advanced/TextToImageControlNet.tsx/TextToImageControlNet";
import TextToImageEnhanceSwitch from "../../../../../../Playground/TextToImage/Config/Advanced/TextToImageEnhanceSwitch.tsx/TextToImageEnhanceSwitch";
import TextToImageNegativePrompt from "../../../../../../Playground/TextToImage/Config/Advanced/TextToImageNegativePrompt/TextToImageNegativePrompt";
import TgFastSwitch from "../../../../../App/Image/Config/Fast/TgFastSwitch";
import styles from "../TgEvaluationConfig.module.scss";

interface TgConfigAdvancedProps {
	scrollContainer: React.RefObject<HTMLElement> | HTMLElement | null;
}

const TgConfigAdvanced = ({ scrollContainer }: TgConfigAdvancedProps) => {
	const { t } = useTranslation("tg", { keyPrefix: "models.viewer.evaluation.config" });
	const accordionRef = useRef<HTMLDivElement>(null);
	const contentRef = useRef<HTMLDivElement>(null);

	return (
		<Accordion
			ref={accordionRef}
			elevation={0}
			disableGutters
			TransitionProps={{ timeout: 200 }}
			className={styles.advancedAccordion}
		>
			<AccordionSummary expandIcon={<ExpandMore />}>{t("label")}</AccordionSummary>
			<Box ref={contentRef} className={styles.advanced}>
				<TextToImageAspectRatio />
				<TgFastSwitch />
				<TextToImageSeed hideDisplayToggle />
				<TextToImageGuidance />
				<TextToImageNegativePrompt />
				<TextToImageEnhanceSwitch />
				<TextToImageControlNet controlNetNumber={1} defaultEnabled scrollContainer={scrollContainer} />
				<TextToImageControlNet controlNetNumber={2} scrollContainer={scrollContainer} />
			</Box>
		</Accordion>
	);
};

export default observer(TgConfigAdvanced);
